import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { is } from 'immutable';
import { MessagesList } from './MessagesList';
import { ScrollHelper } from './ScrollHelper';
import { ChatInputForm } from './ChatInputForm';
import { MoreMessagesBanner } from './MoreMessagesBanner';
import canManage from '../../helpers/discussions/canManage';
import { JOIN_DISCUSSION, LEAVE_DISCUSSION, FETCH_MORE_MESSAGES } from './redux';
import './sagas';
import { connect, dispatch } from '../../store';
import { SOCKET_STATUS } from '../../apis/socket/socket';
export var DiscussionComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(DiscussionComponent, _React$Component);

  var _super = _createSuper(DiscussionComponent);

  function DiscussionComponent(props) {
    var _this;

    _classCallCheck(this, DiscussionComponent);

    _this = _super.call(this, props);

    _this.handleScrollTo = function (event) {
      _this.setState({
        scrolledToBottom: event === 'bottom'
      });

      if (event === 'bottom') {
        _this.setState({
          hasUnreadMessages: false
        });
      }

      if (event === 'top' && _this.props.hasMoreMessages) {
        dispatch(FETCH_MORE_MESSAGES, _this.props.id);
      }
    };

    _this.editMessage = function (message) {
      _this.setState({
        editingMessage: message,
        replyingToMessage: null
      });

      if (message) _this.chatInput.editMessage(message);
    };

    _this.replyToMessage = function (message) {
      _this.setState({
        editingMessage: null,
        replyingToMessage: message
      });

      if (message) _this.chatInput.focus();
    };

    _this.buildMessageActions = function () {
      return {
        editing: _this.state.editingMessage,
        replying: _this.state.replyingToMessage,
        edit: _this.editMessage,
        reply: _this.replyToMessage,
        history: _this.props.toggleMessageHistory
      };
    };

    _this.state = {
      scrolledToBottom: true,
      hasUnreadMessages: false,
      editingMessage: null,
      replyingToMessage: null
    };
    return _this;
  }

  _createClass(DiscussionComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      dispatch(JOIN_DISCUSSION, {
        id: this.props.id,
        invitationToken: this.props.invitationToken
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.id !== prevProps.id) {
        dispatch(LEAVE_DISCUSSION, this.props.id);
        dispatch(JOIN_DISCUSSION, {
          id: this.props.id,
          invitationToken: this.props.invitationToken
        });
      }

      var messages = this.props.discussion && this.props.discussion.messages;
      var prevMessages = prevProps.discussion && prevProps.discussion.messages;

      if (!is(messages, prevMessages)) {
        if (!this.state.scrolledToBottom && messages // get the messages that are newer than the messages we previously
        // had, we do not care about older messages being loaded above only
        // new messages below
        .slice(0, messages.indexOf(prevMessages.first())) // if any of the new messages were not sent by the current user we
        // consider them to be unread
        .some(function (message) {
          return message.createdBy.email !== _this2.props.profile.email;
        })) {
          this.setState({
            hasUnreadMessages: true
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      dispatch(LEAVE_DISCUSSION, this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var DiscussionError = this.props.components.DiscussionError;

      if (this.props.socketStatus !== SOCKET_STATUS.RECONNECTING && this.props.socketStatus !== SOCKET_STATUS.IDENTIFIED) {
        return /*#__PURE__*/React.createElement(DiscussionError, {
          error: "Real-time connection to this server has been interrupted. Please refresh and try again"
        });
      } else if (this.props.error) {
        return /*#__PURE__*/React.createElement(DiscussionError, {
          error: this.props.error
        });
      } else if (this.props.discussion && !this.props.loading) {
        var messageActions = this.buildMessageActions();
        return this.props.render({
          error: this.props.error,
          discussion: this.props.discussion,
          canManage: canManage(this.props.discussion, this.props.profile),
          elements: {
            messages: /*#__PURE__*/React.createElement(ScrollHelper, {
              onScrollTo: this.handleScrollTo,
              ref: function ref(el) {
                return _this3.scrollHelper = el;
              }
            }, /*#__PURE__*/React.createElement(MoreMessagesBanner, {
              hasMore: this.props.hasMoreMessages,
              loading: this.props.loadingMoreMessages
            }), /*#__PURE__*/React.createElement(MessagesList, {
              discussion: this.props.discussion,
              profile: this.props.profile,
              messages: this.props.discussion.messages.reverse(),
              actions: messageActions
            })),
            chatInput: /*#__PURE__*/React.createElement(ChatInputForm, {
              discussion: this.props.discussion,
              messageActions: messageActions,
              registerChatInput: function registerChatInput(el) {
                return _this3.chatInput = el;
              },
              toggleInvitationForm: this.props.toggleInvitationForm
            }),
            viewUnreadButton: this.state.hasUnreadMessages ? /*#__PURE__*/React.createElement("button", {
              type: "button",
              className: "btn btn-primary btn--banner",
              onClick: this.scrollHelper && this.scrollHelper.scrollToBottom
            }, "New messages", /*#__PURE__*/React.createElement("i", {
              className: "fa fa-fw fa-arrow-down",
              "aria-hidden": "true"
            })) : null
          }
        });
      }

      return this.props.loader ? this.props.loader() : null;
    }
  }]);

  return DiscussionComponent;
}(React.Component);
DiscussionComponent.displayName = 'Discussion';
var ConnectedDiscussionComponent = connect(function (state, props) {
  var path = ['discussions', props.id];
  return {
    socketStatus: state.get('socketStatus'),
    discussion: state.getIn(path),
    loading: state.getIn([].concat(path, ['loading'])),
    error: state.getIn([].concat(path, ['error'])),
    hasMoreMessages: state.getIn([].concat(path, ['nextPageToken'])) !== null,
    loadingMoreMessaes: state.getIn([].concat(path, ['loadingMoreMessages']))
  };
})(DiscussionComponent);
export var Discussion = function Discussion(props) {
  return /*#__PURE__*/React.createElement(ConnectedDiscussionComponent, props);
};
export default Discussion;